import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class TpolService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }
  /**
       * Catalogo de tipos de poliza
       * @param filter filter
       * @return La transacción sé ha realizado correctamente
       */
  tpolCatalogo(filter: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/tpol/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    return this.http.post(url_, filter).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }



  /**
   * Baja tipo de poliza
   * @param idGralUsr idGralUsr
   * @param idTpol idTpol
   * @return La transacción sé ha realizado correctamente
   */
  tpolDelete(idTpol: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/tpol/delete/' + idTpol + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  /**
   * Lista de grupos sat
   * @return La transacción sé ha realizado correctamente
   */
  tpolGetGrupo(): Observable<any> {
    let url_ = this.dataUrl + '/tpol/get/grupo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  /**
   * Obtener usuario por id
   * @param id id
   * @return La transacción sé ha realizado correctamente
   */
  tpolGet(id: number): Observable<any> {
    let url_ = this.dataUrl + '/tpol/get/{id}';
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


  /**
   * Crear Usuario
   * @param dto dto
   * @return La transacción sé ha realizado correctamente
   */
  tpolPost(dto: CtbTpolDto): Observable<any> {
    let url_ = this.dataUrl + '/tpol/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  /**
   * Actualizar Usuario
   * @param dto dto
   * @return La transacción sé ha realizado correctamente
   */
  tpolPut(dto: CtbTpolDto): Observable<any> {
    let url_ = this.dataUrl + '/tpol/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}

export class CtbTpolDto implements ICtbTpolDto {
  borrado_logico?: boolean | undefined;
  ctbTpolGrupo?: number | undefined;
  alias?: string | undefined = '';
  emp?: number | undefined;
  folio?: string | undefined;
  gralUsrActualiza?: number | undefined;
  gralUsrBaja?: number | undefined;
  gralUsrCrea?: number | undefined;
  id?: number | undefined;
  momento_actualiza?: Date | undefined;
  momento_baja?: Date | undefined;
  momento_crea?: Date | undefined;
  suc?: number | undefined;
  titulo?: string | undefined;

  tipo_uso?: string | undefined;

  constructor(data?: ICtbTpolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.borrado_logico = _data['borrado_logico'];
      this.ctbTpolGrupo = _data['ctbTpolGrupo'];
      this.emp = _data['emp'];
      this.folio = _data['folio'];
      this.gralUsrActualiza = _data['gralUsrActualiza'];
      this.gralUsrBaja = _data['gralUsrBaja'];
      this.gralUsrCrea = _data['gralUsrCrea'];
      this.id = _data['id'];
      this.momento_actualiza = _data['momento_actualiza'] ? new Date(_data['momento_actualiza'].toString()) : <any>undefined;
      this.momento_baja = _data['momento_baja'] ? new Date(_data['momento_baja'].toString()) : <any>undefined;
      this.momento_crea = _data['momento_crea'] ? new Date(_data['momento_crea'].toString()) : <any>undefined;
      this.suc = _data['suc'];
      this.titulo = _data['titulo'];

      this.tipo_uso = _data['tipo_uso'];
    }
  }

  static fromJS(data: any): CtbTpolDto {
    data = typeof data === 'object' ? data : {};
    let result = new CtbTpolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['borrado_logico'] = this.borrado_logico;
    data['ctbTpolGrupo'] = this.ctbTpolGrupo;
    data['emp'] = this.emp;
    data['folio'] = this.folio;
    data['gralUsrActualiza'] = this.gralUsrActualiza;
    data['gralUsrBaja'] = this.gralUsrBaja;
    data['gralUsrCrea'] = this.gralUsrCrea;
    data['id'] = this.id;
    data['momento_actualiza'] = this.momento_actualiza ? this.momento_actualiza.toISOString() : <any>undefined;
    data['momento_baja'] = this.momento_baja ? this.momento_baja.toISOString() : <any>undefined;
    data['momento_crea'] = this.momento_crea ? this.momento_crea.toISOString() : <any>undefined;
    data['suc'] = this.suc;
    data['titulo'] = this.titulo;

    data['tipo_uso'] = this.tipo_uso;
    return data;
  }
}

export interface ICtbTpolDto {
  borrado_logico?: boolean | undefined;
  alias?: string | undefined;
  ctbTpolGrupo?: number | undefined;
  emp?: number | undefined;
  folio?: string | undefined;
  gralUsrActualiza?: number | undefined;
  gralUsrBaja?: number | undefined;
  gralUsrCrea?: number | undefined;
  id?: number | undefined;
  momento_actualiza?: Date | undefined;
  momento_baja?: Date | undefined;
  momento_crea?: Date | undefined;
  suc?: number | undefined;
  titulo?: string | undefined;

  tipo_uso?: string | undefined;
}

export class CtbTpolGrupoDto implements ICtbTpolGrupoDto {
  id?: number | undefined;
  titulo?: string | undefined;
}

export interface ICtbTpolGrupoDto {
  id?: number | undefined;
  titulo?: string | undefined;
}
export class CtbTpolCatalogoDto implements ICtbTpolCatalogoDto {
  id?: number | undefined;
  folio?: string | undefined;
  titulo?: string | undefined;
  tipoSat?: string | undefined;
}

export interface ICtbTpolCatalogoDto {
  id?: number | undefined;
  folio?: string | undefined;
  titulo?: string | undefined;
  tipoSat?: string | undefined;
}
export class PageBusquedaObject implements IPageBusquedaObject {
    column?: string | undefined;
    criteriaSearch?: any | undefined;
    itemsPerPage?: number | undefined;
    order?: string | undefined;
    pageNumber?: number | undefined;
    sort?: boolean | undefined;

    constructor(data?: IPageBusquedaObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)){
                    (<any>this)[property] = (<any>data)[property];
                  }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data['column'];
            this.criteriaSearch = _data['criteriaSearch'];
            this.itemsPerPage = _data['itemsPerPage'];
            this.order = _data['order'];
            this.pageNumber = _data['pageNumber'];
            this.sort = _data['sort'];
        }
    }

    static fromJS(data: any): PageBusquedaObject {
        data = typeof data === 'object' ? data : {};
        let result = new PageBusquedaObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['column'] = this.column;
        data['criteriaSearch'] = this.criteriaSearch;
        data['itemsPerPage'] = this.itemsPerPage;
        data['order'] = this.order;
        data['pageNumber'] = this.pageNumber;
        data['sort'] = this.sort;
        return data;
    }
}

export interface IPageBusquedaObject {
    column?: string | undefined;
    criteriaSearch?: any | undefined;
    itemsPerPage?: number | undefined;
    order?: string | undefined;
    pageNumber?: number | undefined;
    sort?: boolean | undefined;
}
